import { AxiosResponse } from 'axios';
import {GeometryObject, Polygon} from 'geojson';
import v1 from '../v1';

export async function fetchForbiddenAreas<T extends GeometryObject>(center: ILngLat, radius: number): Promise<AxiosResponse<Array<{
  _id: string;
  path: Polygon;
  state:number;
}>>> {
  return await v1({
    url: '/operation/polygon/near',
    params: {
      query: {
        type: 2,
      },
      center,
      radius,
    },
  });
}

export async function fetchForbiddenDetail(_id:string):Promise<AxiosResponse<{
  count:number,
  items:any,
}>> {
  return await v1({
    url:'/operation/polygon',
    params:{
      query:{
        _id,
      }
    }
  })
}

export async function unlockPolygon(id:string, data:any):Promise<AxiosResponse<{

}>> {
    return await v1({
        url:`/operation/polygon/${id}/state`,
        method:'put',
        data,
    })
}

export async function updateForbiddenAreas(id:string, data:any):Promise<AxiosResponse<{
  _id:string;
}>> {
  return await v1({
    method:'put',
    url:`/operation/polygon/${id}`,
    data,
  })
}

export async function fetchProhibitedAreas(): Promise<AxiosResponse<{
  count: number;
  items: Array<{
    _id: string;
    path: Polygon;
  }>
}>> {
  return await v1({
    url: '/operation/polygon',
    params: {
      query: {
        type: 3,
        enable: true,
        isCleaned: false,
      },
      limit: 10000,
    },
  });
}

export async function fetchInspectionAreas(): Promise<AxiosResponse<{
  count: number;
  items: Array<{
    _id: string;
    path: Polygon;
  }>
}>> {
  return await v1({
    url: '/operation/polygon',
    params: {
      query: {
        type: 4,
        enable: true,
        isCleaned: false,
      },
      limit: 10000,
    },
  });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/api/operation/polygon.ts